import { helper } from '@ember/component/helper';

import { join } from 'rise-ui/utils/string.js';

export default helper(function concatClassesHelper(params) {
  return join([].concat(params || []).filter(c => c), ' ');
});
